const OVERLAYS = {
  menu: 'menu',
  nav: 'nav',
  otc: 'otc',
  quickbuy: 'quickbuy',
  addfunds: 'addfunds',
  cardAuthorization: 'cardAuthorization',
  tos: 'tos'
};

export default OVERLAYS;
